<script>
import $ from 'jquery';

/* COMPOSANTS */
import AkFormSubmitted from '@components/general/AkFormSubmitted';
import GaMessages from '@components/ga/layout/GaMessages';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import AkButtonValidationV2 from '../v2/general/AkButtonValidationV2.vue';
import {PerfectScrollbar} from 'vue3-perfect-scrollbar';

/* MIXINS */
/* SERVICES */

export default {
  components: {PerfectScrollbar, AkButtonValidationV2, AkButtonValidation, AkFormSubmitted, GaMessages},
  props: {
    width: {type: String, default: '600px'},
    btnSuccessClass: {type: String, default: 'btn-blue'},
    btnCancelClass: {type: String, default: 'btn-grey-outline'},
    cancelLabel: {type: String, default: undefined},
    validateLabel: {type: String, default: undefined},
    autoHideOnValidate: {type: Boolean, default: false},
    autoHideOnCancel: {type: Boolean, default: true},
    showValidateButton: {type: Boolean, default: true},
    showCancelButton: {type: Boolean, default: true},
    disableValidateButton: {type: Boolean, default: false},
    noHeader: {type: Boolean, default: false},
    paddingOnHeader: {type: Boolean, default: false},
    paddingOnScrollbar: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    title: {default: false},
    dismissable: {type: Boolean, default: false},
    contentClass: {type: String, default: ''},
    footerClassName: {type: String, default: ''},
  },
  emits: ['show', 'hide', 'cancel', 'validate'],
  data() {
    return {
      display: false,
      submitted: false,
    };
  },
  computed: {
    buildCancelLabel() {
      return this.cancelLabel ? this.cancelLabel : this.$t('cancel');
    },
    buildValidateLabel() {
      return this.validateLabel ? this.validateLabel : this.$t('validate');
    },
    footerClass() {
      let footerClass = 'flex justify-between gap-2 w-full';
      if (this.footerClassName) footerClass += ' ' + this.footerClassName;
      return footerClass;
    },
  },
  mounted() {},
  methods: {
    init() {
      if (this.$refs.btnValid) this.$refs.btnValid.init();
    },
    show() {
      this.submitted = false;
      this.setDisplay(true);
      this.$emit('show');
    },
    hide() {
      this.setDisplay(false);
      this.$emit('hide');
    },
    cancel() {
      if (this.autoHideOnCancel) this.setDisplay(false);
      this.$emit('cancel');
    },
    validate() {
      this.submitted = true;
      if (this.autoHideOnValidate) this.setDisplay(false);
      this.$emit('validate');
    },
    setDisplay(value) {
      this.display = value;
    },
    success(msg) {
      this.$refs.messages.success(msg);
      this.init();
      this.scrollTop();
    },
    error(msg) {
      this.$refs.messages.error(msg);
      this.init();
      this.scrollTop();
    },
    resetMessages() {
      this.$refs.messages.resetMessages();
    },
    scrollTop() {
      $('.p-dialog-content').scrollTop(0);
    },
    resetScroll() {
      const scrollbar = this.$refs.scrollbar;
      if (!scrollbar) return;
      scrollbar.$el.scrollTop = 0;
      scrollbar.ps?.update();
    },
  },
};
</script>

<template>
  <PDialog
    :autoZIndex="false"
    v-model:visible="display"
    :modal="true"
    class="dialog-headless"
    :pt="{
      mask: {class: 'headless'},
    }"
    :style="{width: width}"
    :dismissable-mask="dismissable"
    block-scroll
    @hide="hide"
    @update:visible="cancel"
    :closable="!this.$slots.header"
    :content-class="contentClass + ' flex-col'"
    :class="[
      {
        'no-footer': !this.showValidateButton && !this.showCancelButton && !this.$slots.footer,
        'no-header': this.noHeader,
        'default-header': !this.$slots.header,
        'padding-on-scrollbar': this.paddingOnScrollbar,
        'padding-on-header': this.paddingOnHeader,
      },
    ]">
    <template #header>
      <slot name="header"></slot>
    </template>
    <GaMessages ref="messages" />
    <perfect-scrollbar
      ref="scrollbar"
      class="w-full"
      :class="{'!px-6': this.paddingOnScrollbar}"
      :options="{suppressScrollX: true, scrollYMarginOffset: 1}">
      <span v-if="title" class="font-inter font-bold text-xl text-grey-900 flex items-center justify-center mb-4">
        {{ title }}
      </span>
      <AkFormSubmitted :submitted="submitted" :disabled="disabled" reference="form">
        <slot />
      </AkFormSubmitted>
    </perfect-scrollbar>
    <template #footer>
      <div :class="footerClass" v-if="this.showCancelButton || this.showValidateButton">
        <span v-if="this.showCancelButton" :class="btnCancelClass" @click="cancel">
          {{ buildCancelLabel }}
        </span>
        <AkButtonValidationV2
          ref="btnValid"
          :btn-class="btnSuccessClass"
          :label="buildValidateLabel"
          :little="false"
          :disabled="disableValidateButton"
          v-if="this.showValidateButton"
          @action="validate"></AkButtonValidationV2>
      </div>
      <slot name="footer" class="flex justify-between gap-2 w-full" v-else></slot>
    </template>
  </PDialog>
</template>
